<template>
<!-- 登录页面 -->
  <div class="BGS">
    <div class="login_box">
      <div class="login_box_left">
        <img src="../assets/img/login_bg2.png" alt="">
      </div>

      <div class="login_box_right">
        <img class="login_box_dengpao" src="../assets/img/login_bg3.png" alt="">
        <div class="login">
          <div class="login_title">欢迎登录</div>
          <div class="login_tips">请使用您本人的账号密码登录</div>
          <input type="text" class="ipt" v-model="phone" placeholder="手机号">
          <input type="password" class="ipt" v-model="password" placeholder="密码">
          <div class="forget_password">
            <div>忘记密码?</div>
            <div>没有账号？<a href="https://www.qudong.com/user/reg.html" style="color:#3463DB">去注册</a></div>
          </div>
          <button class="Go_login" @click="Go_login">登录</button>
          <div class="login_fs">—— 切换登陆方式 ——</div>
          <div class="icon_s">
            <img src="../assets/img/phone_icon.png" title="手机登录" @click="Go_phone_lg" alt="">
            <img src="../assets/img/mechat_icon.png" title="微信登录" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
export default {
  metaInfo(){
     return{
        title: '登录页面_驱动中国研究院',
        meta: [
            {
                name: 'keywords',
                content: '驱动中国研究院是一家全行业的自媒体平台，提供新闻资讯聚合数据挖掘与引擎算法智能推荐。提供个性化资讯服务，全方位打造商圈自媒体平台，提供连接人与信息的智能服务，打造国内有价值的移动自媒体平台。'
            },
            {
                name: 'description',
                content:' 驱动中国研究院，专利转让，研究报告，科研资讯，驱动中国研究院官网'
            }
        ]
     }     
    },
  name: "login",
  data() {
    return {
      phone: "",
      password: "",
    };
  },
  methods: {
    Go_login() {
      var that = this;
      if (!that.phone) {
        return that.$message.warning("手机号不能为空");
      }
      if (!that.password) {
        return that.$message.warning("密码不能为空");
      }
      Axios({
        method: "post",
        url: "https://weixin.qudong.com/api/user/login",
        params: {
          username: that.phone,
          password: that.$md5(that.password),
        },
      }).then((res) => {
        ////console.log(res);
        if (res.data.code == 200) {
          that.$message.success(res.data.msg);
          localStorage.setItem("userInfo", JSON.stringify(res.data.data)); //用户信息
          localStorage.setItem("token", res.data.data.token); //token
          localStorage.setItem("userimgurl", res.data.data.headimgurl); //用户图片
          localStorage.setItem("usernickname", res.data.data.nickname); //用户名称
          setTimeout("location.href='/'",1500);
        } else {
          that.$message.warning(res.data.msg);
        }
      });
    },
    Go_phone_lg() {
      this.$router.push("/phonelogin");
    },
  },
  mounted() {},
};
</script>

<style scoped>
.BGS {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #619ded;
  background-image: url("../assets/img/login_bg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.login_box {
  width: 1500px;
  height: 800px;
  background: #fff;
  margin: 2% auto 5% auto;
  border-radius: 0 20px 20px 0;
  display: flex;
}
.login_box_left {
  width: 50%;
}
.login_box_left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.login_box_right {
  width: 50%;
  position: relative;
}
.login_box_dengpao {
  position: absolute;
  right: 40px;
  top: 0;
}
.login {
  padding: 100px 100px;
}
.login_title {
  font-size: 60px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #3463db;
}
.login_tips {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
}
.ipt {
  margin-top: 30px;
  width: 525px;
  height: 80px;
  border: 1px solid #b1b3cc;
  border-radius: 8px;
  font-size: 24px;
  padding-left: 5px;
}
input::-webkit-input-placeholder {
  /* 修改字体颜色 */
  color: #999999;
}
.forget_password {
  width: 525px;
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
}
.forget_password div:nth-child(1) {
  color: #999999;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
}
.forget_password div:nth-child(2) {
  color: #999999;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
}
.forget_password a {
  cursor: pointer;
}
.Go_login {
  margin-top: 20px;
  width: 525px;
  height: 80px;
  background: #3463db;
  border-radius: 40px;
  text-align: center;
  line-height: 80px;
  color: #fff;
  font-size: 30px;
  cursor: pointer;
  border: none;
}
.login_fs {
  width: 525px;
  text-align: center;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #999999;
  margin-top: 50px;
}
.icon_s {
  width: 180px;
  display: flex;
  margin: 10px auto;
  justify-content: space-around;
}
.icon_s img {
  width: 60px;
  height: 60px;
  cursor: pointer;
}
</style>